import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { TOption, TSelectorProps } from "./dropMenu.types";

const SelectorUnstyled = ({
  placeholder = "Select any option",
  label,
  value,
  onChange,
  options,
  error,
  disabled = false,
  className = "",
  accessorKey = "name",
  anchorPosition = "bottom",
}: TSelectorProps) => {
  // Function to handle change in select option
  function handleChange(option: TOption) {
    onChange(option);
  }

  return (
    <div className="relative w-full">
      <Listbox onChange={handleChange} disabled={disabled}>
        <p className="text-xs font-semibold tracking-wider text-body pl-1">
          {label}
        </p>

        <ListboxButton
          className={`w-full h-10 outline-none text-sm
          flex items-center justify-between text-body font-semibold pl-2 pr-1 ${className}
       disabled:cursor-not-allowed disabled:opacity-70 disabled:bg-extraLightGray/30 `}
        >
          <span
            data-error={error?.message ? true : false}
            className={`text-sm line-clamp-1 ${
              value?.[accessorKey]
                ? "text-subHeading font-semibold"
                : "text-darkGray/80 data-[error=true]:text-error/70 font-medium"
            }`}
          >
            {value?.[accessorKey] || placeholder}
          </span>
          <span
            data-error={error?.message ? true : false}
            className="text-gray data-[error=true]:text-error/70"
          >
            <ChevronUpDownIcon className="h-5 w-5" aria-hidden="true" />
          </span>
        </ListboxButton>
        <ListboxOptions
          anchor={anchorPosition}
          transition
          className="
                    absolute
                    w-[var(--button-width)]
                    min-w-44
                    max-h-48
                    overflow-y-auto
                    shadow-md
                    border
                    bg-white
                    border-extraLightGray
                    rounded-md
                    outline-none
                    z-50
                  "
        >
          {options?.length > 0 ? (
            options?.map((option) => (
              <ListboxOption
                key={option?.id}
                value={option}
                className="px-4 py-2 text-sm font-semibold transition-colors cursor-auto select-none  outline-none
                 data-[selected]:text-white data-[selected]:bg-primary data-[focus]:text-body data-[focus]:bg-primary/20"
              >
                {option?.[accessorKey]}
              </ListboxOption>
            ))
          ) : (
            <div className="flex text-sm font-semibold text-heading px-4 py-2 ">
              No Data found !
            </div>
          )}
        </ListboxOptions>
      </Listbox>
    </div>
  );
};

export default SelectorUnstyled;
